import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Subscription } from "rxjs"
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { BasketService } from '../../../../../basket/shared/basket.service'
import { ArticlePorteur } from "../../../shared/articles/article"
import { Porteur } from '../../../shared/porteur'
import { PorteurService } from "../../../shared/porteur.service"
import { typeFamille } from "./famille"
import { logos } from "./logos"
import { ValRetArticleComponent } from './val-ret-article/val-ret-article.component'

@Component({
  selector: 'app-card-article',
  templateUrl: './card-article.component.html',
  styleUrls: ['./card-article.component.scss']
})
export class CardArticleComponent implements OnInit {

  @Input()
  article: ArticlePorteur;

  @Input()
  porteur: Porteur;

  @Output()
  onEdit: EventEmitter<ArticlePorteur> = new EventEmitter<ArticlePorteur>();

  logos = logos;
  load: Subscription;
  typeFamille = typeFamille;

  constructor(
    private porteurService: PorteurService,
    private basketService: BasketService,
    private notificationService: NotificationService,
    private validDialog: MatDialog
  ) { }

  ngOnInit() {
  }

  private openDialog(): void {
    const dialogRef = this.validDialog.open(ValRetArticleComponent, {
      data: {
        porteur: this.porteur,
        article: this.article
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.basketService.addBasketLine({
          type: 'RETRAIT ARTICLE',
          numPorteur: this.porteur.numPorteur,
          article: this.article.code_article,
          taille: this.article.taille,
          codeService: this.porteur.codeService
        }).subscribe(res => this.success());
      }
    });
  }

  getSvg(): string {
    let pictoFamille = this.findTypeFamille();
    if (pictoFamille) {
      return logos[pictoFamille['type']];
    }
  }

  findTypeFamille() {
    let cle_ref = this.article.famille.cle_ref.toString();
    let pictoFamille;
    let breakIt = false;
    for (let type of this.typeFamille) {
      for (let article of type['articles']) {
        if (cle_ref.match(article['famille']) || article['famille'] == cle_ref) {
          if (this.article.code_article.match(article['code'])) {
            pictoFamille = type;
            breakIt = true;
            break;
          }
        }
      }
      if (breakIt === true) {
        break;
      }
    }
    return pictoFamille;
  }

  /**
   *
   * @param row
   * @returns {Promise<void>}
   */
  openEdit() {
    if (this.article) {
      this.onEdit.next(this.article);
    }
  }

  private success() {
    this.notificationService.notif("Votre demande de retrait d'article a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }

  delete() {
    if (this.article !== undefined && this.porteur !== undefined) {
      this.openDialog();
    }
  }

}
